<template>
  <div class="content--sinoreg page--habilitarNascimento">
    <header-blue class="headerBlueEdicao">
      <h4 class="resumo-show_title pl-2">
        <b-row>
          <b-col sm="3"
                 class="casamentoTitle">
            <icon-svg icon="engagement"
                      class="icon--md icons--white typeIcon" />
            Casamento
          </b-col>
          <b-col sm="9"
                 class="headerEditHabilitacao">
            <b-row>
              <HeaderBoxCasamento v-if="casamento.registro.registro_id"
                                  info-title="Cônjuge 1"
                                  :info-name="casamento.registro.pessoas[0].nome_antigo"
                                  :info-cpf="casamento.registro.pessoas[0].cpf | cpf" />
            </b-row>
            <b-row>
              <HeaderBoxCasamento v-if="casamento.registro.registro_id"
                                  info-title="Cônjuge 2"
                                  :info-name="casamento.registro.pessoas[1].nome_antigo"
                                  :info-cpf="casamento.registro.pessoas[1].cpf | cpf" />
            </b-row>
            <b-row>
              <HeaderBoxResume v-if="casamento.registro.registro_id"
                               :info="casamento.registro.data_ocorrido | date"
                               text="Data do ocorrido" />
              <HeaderBoxResume v-if="casamento.registro_id"
                               :info="casamento.registro.data_registro | date"
                               text="Data de registro" />
              <HeaderBoxResume v-if="casamento.registro.registro_id"
                               class="matricula_id"
                               :info="casamento.registro.matricula | maskMatricula"
                               text="Matrícula" />
            </b-row>
          </b-col>
        </b-row>
      </h4>
    </header-blue>

    <div class="Resumo EdicaoHabilitacaoCasamento">
      <b-tabs content-class="mt-2"
              class="Resumo-border"
              align="left"
              :active-nav-item-class="errosAbas.indexOf(tab_atual + 1) != -1 ? 'Resumo--tab-active_error': 'Resumo--tab-active'">
        <b-tab active
               @click="tab_atual = 0">
          <template v-slot:title>
            <div :class="{'nav-link_error':errosAbas.indexOf(1) != -1 && tab_atual != 0}">
              Cônjuge 1
              <IconSvg v-if="errosAbas.indexOf(1) != -1"
                       class="icon-error"
                       icon="alert" />
            </div>
          </template>

          <conjugue :prop-pessoa="casamento.registro.pessoas[0]"
                    :prop-ordem="0"
                    :prop-habilitacao="casamento"
                    :prop-cartorio="dadosCartorio"
                    :prop-correcoes="correcoes"
                    :prop-componente-pai="$options.name"
                    @deleteError="deleteError"
                    @onChange="changeConjugue"
                    @onDeleteds="changeDeleteds" />
        </b-tab>

        <b-tab @click="tab_atual = 1">
          <template v-slot:title>
            <div :class="{'nav-link_error':errosAbas.indexOf(2) != -1 && tab_atual != 1}">
              Cônjuge 2
              <IconSvg v-if="errosAbas.indexOf(2) != -1"
                       class="icon-error"
                       icon="alert" />
            </div>
          </template>

          <conjugue :prop-pessoa="casamento.registro.pessoas[1]"
                    :prop-ordem="1"
                    :prop-habilitacao="casamento"
                    :prop-cartorio="dadosCartorio"
                    :prop-correcoes="correcoes"
                    :prop-componente-pai="$options.name"
                    @deleteError="deleteError"
                    @onChange="changeConjugue"
                    @onDeleteds="changeDeleteds" />
        </b-tab>

        <b-tab @click="tab_atual = 2">
          <template v-slot:title>
            <div :class="{'nav-link_error':errosAbas.indexOf(3) != -1 && tab_atual != 2}">
              Dados do Casamento
              <IconSvg v-if="errosAbas.indexOf(3) != -1"
                       class="icon-error"
                       icon="alert" />
            </div>
          </template>

          <DadosCasamento :prop-habilitacao="casamento"
                          :prop-registro="casamento.registro"
                          :prop-cartorio="dadosCartorio"
                          :prop-tipo="'CASAMENTO'"
                          :prop-correcoes="correcoes"
                          :prop-edicao="true"
                          :prop-tab="tab_atual"
                          @deleteError="deleteError"
                          @onChange="changeDadosCasamento"
                          @onDeleteds="changeDeleteds" />
        </b-tab>

        <b-tab @click="tab_atual = 3">
          <template v-slot:title>
            <div :class="{'nav-link_error':errosAbas.indexOf(4) != -1 && tab_atual != 3}">
              Registro
              <IconSvg v-if="errosAbas.indexOf(4) != -1"
                       class="icon-error"
                       icon="alert" />
            </div>
          </template>

          <Registro :prop-registro="casamento.registro"
                    :prop-correcoes="correcoes"
                    :prop-tab="tab_atual"
                    @deleteError="deleteError"
                    @change="changeRegistro" />
        </b-tab>

        <b-tab v-if="!!casamento.registro.transporte"
               @click="tab_atual = 4">
          <template v-slot:title>
            <div :class="{'nav-link_error':errosAbas.indexOf(5) != -1 && tab_atual != 4}">
              Transporte
              <IconSvg v-if="errosAbas.indexOf(5) != -1"
                       class="icon-error"
                       icon="alert" />
            </div>
          </template>

          <AbaTransporte :prop-correcoes="correcoes"
                         :data="casamento"
                         @change="changeRegistro" />
        </b-tab>
      </b-tabs>
    </div>

    <hr>
    <div class="row mt-2">
      <div class="col">
        <ExcluirCancelarRegistro v-if="casamento && casamento.registro_id"
                                 :prop-registro="casamento.registro"
                                 :registro-id="casamento.registro_id"
                                 @onBlockUpdate="status => bloquearRegistro(status)" />
      </div>
      <div class="col text-right">
        <button id="btn-submit-cancel"
                class="btn btn-sm btn-dark"
                @click="goResumo">
          Voltar
        </button>

        <div v-if="casamento.registro && casamento.registro.existe_crc"
             class="d-inline-block ml-2">
          <button id="btn-submit-registro-alteracao"
                  v-b-modal.modalMotivoAlteracao
                  class="btn btn-sm btn-secondary ml-2"
                  type="button">
            Salvar
          </button>
        </div>
        <button v-else
                id="btn-submit-registro"
                class="btn btn-sm btn-secondary ml-2"
                @click="atualizarRegistro()">
          Salvar
        </button>
      </div>
    </div>
    <MotivoAlteracao tipo="C"
                     :tarefa-alteracao-carga="tarefaAlteracaoCarga"
                     @gravarAtualizacao="atualizarRegistro($event)" />
  </div>
</template>

<script>
  /* components */
  import Conjugue from "@/components/SofiaRei/HabilitacaoCasamento/Conjugue"
  import HeaderBlue from "@/components/SofiaRei/Headers/HeaderBlue"
  import HeaderBoxResume from "@/components/SofiaRei/Busca/HeaderBoxResume"
  import HeaderBoxCasamento from "@/components/SofiaRei/Busca/HeaderBoxCasamento"
  import ExcluirCancelarRegistro from '@/components/SofiaRei/ExcluirCancelarRegistro'
  import DadosCasamento from "@/components/SofiaRei/HabilitacaoCasamento/DadosCasamento"
  import Registro from "@/components/SofiaRei/Casamento/Registro"
  import MotivoAlteracao from '@/components/SofiaRei/Resumo/MotivoAlteracao.vue'
  import AbaTransporte from "@/components/SofiaRei/AbaTransporte.vue"

  /* services */
  import CartorioService from "@/services/CartorioService"
  import CasamentoService from "@/services/Registros/Casamento"

  /* others */
  import { mapGetters } from "vuex"
  import moment from 'moment'

  export default {
    name: "EditarCasamento",
    components: {
      HeaderBlue,
      HeaderBoxResume,
      HeaderBoxCasamento,
      Conjugue,
      DadosCasamento,
      ExcluirCancelarRegistro,
      Registro,
      MotivoAlteracao,
      AbaTransporte
    },
    props: {
      propCasamento: { type: Object, default: () => ({})},
      propCorrecoes: { type: Object, default: () => ({})}
    },
    data () {
      return {
        casamento: {
          documentos: [],
          tipo_casamento: null,
          regime_bens: null,
          casamento_em_cartorio: true,
          registro: {
            cartorio_id: this.$store.state.auth.cartorio_id,
            tipo_registro: "C",
            hora_ocorrido: null,
            data_ocorrido: null,
            data_registro: null,
            matricula: '00000000000000000000000000000000',
            partes: [],
            tarefas: [],
            pessoas: [
              {
                nome: '',
                genitores: []
              },
              {
                nome: '',
                genitores: []
              }
            ],
            local: {
              descricao: null,
              endereco: {}
            },
            livro: {}
          },
          ...this.propCasamento
        },
        dataInicio: '',
        dadosCartorio: {},
        errosAbas: [],
        correcoes: {...this.propCorrecoes},
        tab_atual: 0,
        tarefaAlteracaoCarga: null,
        deleteds: {
          partes: [],
          genitores: [],
          pessoaDocumentos: [],
          registrosAnteriores: [],
          habilitacaoDocumentos: [],
          pessoaEnderecos: []
        },
        limitDate: moment(new Date()).add(1, 'day').format('YYYY-MM-DD')
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId',
        cartorio: 'auth/getCartorioObj'
      })
    },
    watch: {
      propCorrecoes () {
        this.correcoes = {...this.propCorrecoes}
      }
    },
    created () {
      this.getCartorio()
      if (Object.values(this.propCasamento).length > 0) {
        this.casamento = this.propCasamento

        this.tratarData()
      }
      else this.init()
    },
    mounted () {
      this.verifyCorrecoes().abas()
      this.controlEvent().addEvent()
    },
    methods: {
      async getCartorio () {
        const cartorio = await CartorioService.getCartorioRei(this.$store.state.auth.cartorio_id)
        this.dadosCartorio = cartorio.data
      },
      async init () {
        try {
          loader({ text: "Carregando...", active: true })

          this.casamento = await CasamentoService.getCasamento(this.$route.params.id)

          this.tratarData()
          this.tratarLocal()

        } catch (e) {
          console.error(e)
        } finally {
          loader({text: "Carregando...", active: false })
        }

        this.tarefaAlteracaoCarga = this.casamento.registro.tarefas.find((tarefa) => {
          return tarefa.acao === 'ALTERACAO' && tarefa.tipo === 'CARGA'
        })
      },
      changeConjugue (conjugue) {
        this.casamento.registro.pessoas[conjugue.ordem] = conjugue.pessoa
      },
      changeDadosCasamento (casamento) {
        this.casamento = casamento

        if (casamento.tipo_casamento == 'Casamento Religioso com efeito civil' || casamento.tipo_casamento == 'Religioso com efeito civil com Habilitação posterior') this.casamento.registro.tipo_registro = "CR"
        else this.casamento.registro.tipo_registro = "C"
      },
      changeRegistro (registro) {
        this.casamento.registro = registro
      },
      goResumo () {
        this.$router.push({ name: 'resumo_casamento', params: { id: this.$route.params.id }})
      },
      changeDeleteds (deleted) {
        const key = Object.keys(deleted)[0]
        this.deleteds[key].push(deleted[key])
      },
      displaySuccess (title, text) {
        objSwal.success.title = title
        objSwal.success.text = text
        objSwal.success.html = null

        return Swal.fire(objSwal.success).then(res => {
          objSwal.success.title = null
          objSwal.success.text = null
          objSwal.success.html = null

          return res
        })
      },
      displayError (type, message) {
        objSwal.error.title = 'Erro ao atualizar registro de casamento'

        if (type === 'HTML') {
          objSwal.error.text = ''
          objSwal.error.html = message
        } else {
          objSwal.error.text = message
          objSwal.error.html = ''
        }

        loader({ text: '', active: false })

        return Swal.fire(objSwal.error).then(() => {
          objSwal.error.text = ''
          objSwal.error.html = ''
        })
      },
      async atualizarRegistro ($event = null) {
        const menores = []

        this.casamento.registro.pessoas.forEach(pessoa => {
          if (pessoa.idade && pessoa.idade < 16) {
            menores.push(pessoa.nome_antigo)
          }
        })

        if (menores.length) {
          const resp = await displayMessage('question', 'Alerta!', `Existem contraentes com idade inferior a 16 anos. Tem certeza que deseja continuar?`)

          if (!resp.value) {
            return
          }
        }

        const data = $event

        try {
          loader({active: true, text: 'Atualizando registro...'})

          if (data) {
            this.casamento.registro.cod_motivo_alt = data.codigo
            this.casamento.registro.data_averb_motivo_alt = data.dataAverb
            this.$root.$emit('bv::hide::modal', `modalMotivoAlteracao`)
          }

          let data_atual = null

          if (this.casamento.tipo_casamento == 'Afixação de edital de outra serventia') {
            data_atual = moment().format('YYYY-MM-DD')
          }

          // caso não tenha data casamento vai ser a atual (data atual só vai ter se for 'Afixação de edital de outra serventia')
          this.casamento.registro.data_ocorrido = this.casamento.data_casamento || data_atual
          this.casamento.registro.hora_ocorrido = this.casamento.hora_casamento || moment().format('H:mm')

          if (!this.casamento.registro.oficial) {
            this.casamento.registro.oficial = this.cartorio.nome_oficial
          }

          //deleteds
          this.casamento.deleteds = this.deleteds

          const errors = this.verifyInputs()

          if (errors.length) {
            this.showErrorList(errors)
          } else {
            const res = await CasamentoService.updateCasamento(this.casamento, this.$route.params.id)

            if (res) {
              this.displaySuccess(null, 'Registro atualizado com sucesso.').then(() => {
                this.$router.push({name: 'resumo_casamento', params: {id: res.casamento_id}})
              })
            }
          }
        } catch (error) {
          if (Array.isArray(error.response && error.response.data)) {
            const messages = []

            error.response.data.forEach(resp => {
              switch (resp.message) {
              case 'in validation failed on registro.pessoas.0.estado_civil':
                messages.push('Informe o estado civil do Cônjuge 1')
                break
              case 'in validation failed on registro.pessoas.1.estado_civil':
                messages.push('Informe o estado civil do Cônjuge 2')
                break
              }
            })
            if (!!messages) {
              this.showErrorList(messages)
            } else {
              this.displayError('TEXT', error.message)
            }

          } else {
            this.displayError('TEXT', 'Houve algum erro ao editar o registro de Casamento, favor contactar o suporte.')
          }
        } finally {
          loader({ active: false, text: ''})
        }
      },
      tratarData () {
        if (this.casamento.data_casamento) {
          this.casamento.data_casamento = moment(this.casamento.data_casamento).format('YYYY-MM-DD')
        }
      },
      tratarLocal () {
        if (this.casamento.registro && !this.casamento.registro.local) {
          this.casamento.registro.local = {}
        }
      },
      verifyCorrecoes () {
        const aba = (num) => {
          if (Object.values(this.correcoes).indexOf(num) != -1) return true
        }

        const abas = () => {
          this.errosAbas = Object.values(this.correcoes)
        }

        const campos = (name) => {
          const keys = Object.keys(this.correcoes)

          if (Array.isArray(name)) {
            const equals = name.filter(val => {
              let find = false

              keys.forEach(key => {
                if (key.match(val)) find = true
              })

              return find
            })

            if (equals.length) return true
          } else {
            let find = false

            keys.forEach(key => {
              if (key.match(name)) find = true
            })

            return find
          }
        }

        return { aba, abas, campos }
      },
      deleteError (errors) {
        errors.forEach(error => {
          delete this.correcoes[error]
          this.correcoes = {...this.correcoes}
          this.verifyCorrecoes().abas()
        })
      },
      controlEvent () {
        const addEvent = () => {
          setTimeout(() => {
            const abas = document.querySelectorAll('.nav-link')
            const btnSubmit = (this.casamento.registro && this.casamento.registro.existe_crc) ? document.querySelector('#btn-submit-registro-alteracao') : document.querySelector('#btn-submit-registro')
            const btnCancel = document.querySelector('#btn-cancel-registro')

            if (abas.length) {
              abas.forEach(aba => {
                aba.onkeydown = nextAba
              })

              abas[0].focus()
            }

            if (btnSubmit) {
              btnSubmit.onkeydown = firstAba
            }

            if (btnCancel) {
              btnCancel.onkeydown = firstAba
            }
          }, 400)
        }

        const nextAba = (event) => {
          if (event.key != 'Tab') return

          const abas = document.querySelectorAll('.nav-link')
          const abasArr = Array.from(abas)

          const index = abasArr.findIndex(aba => aba.id == event.target.id)

          if (index != -1 && index != abasArr.length - 1) {
            setTimeout(() => {
              abas[index + 1].focus()
              abas[index + 1].scrollIntoView({ block: 'center', inline: "nearest" })
            })
          } else if (index != -1 && index == abasArr.length - 1) {
            setTimeout(() => {
              abas[index].scrollIntoView({ block: 'center', inline: "nearest" })
            })
          }
        }

        const firstAba = (event) => {
          if (event.key != 'Tab') return

          const abas = document.querySelectorAll('.nav-link')
          const btnSubmit = (this.casamento.registro && this.casamento.registro.existe_crc) ? document.querySelector('#btn-submit-registro-alteracao') : document.querySelector('#btn-submit-registro')

          if (abas) {
            if (event.target.id == 'btn-cancel-registro' && (btnSubmit && btnSubmit.disabled) || event.target.id == 'btn-submit-registro') {
              setTimeout(() => {
                abas[0].focus()
              }, 100)
            }
          }
        }

        return { addEvent, nextAba, firstAba }
      },
      //Verificando campos obrigatorios
      verifyInputs () {
        const messageErrors = []
        if (!this.casamento.registro.escrevente) {
          messageErrors.push('Informe o escrevente do registro')
        }
        if (!this.casamento.registro.digitador) {
          messageErrors.push('Informe o digitador do registro')
        }
        if (!this.casamento.registro.pessoas[0].nome_antigo || !this.casamento.registro.pessoas[1].nome_antigo ) {
          this.casamento.registro.pessoas.forEach((pessoa, index) => {
            if (!pessoa.nome_antigo) {
              messageErrors.push(`Informe o nome do cônjuge ${index + 1}`)
            }
          })
        }
        if ((!!this.casamento.registro.pessoas[0].data_nascimento && this.casamento.registro.pessoas[0].idade < 14) || this.casamento.registro.pessoas[0].data_nascimento > this.limitDate ) {
          messageErrors.push(`Data de nascimento do cônjuge 1 inválida`)
        }
        if ((!!this.casamento.registro.pessoas[1].data_nascimento && this.casamento.registro.pessoas[1].idade < 14) || this.casamento.registro.pessoas[1].data_nascimento > this.limitDate ) {
          messageErrors.push(`Data de nascimento do cônjuge 2 inválida`)
        }
        if (!this.casamento.tipo_casamento) {
          messageErrors.push('Informe o tipo de Casamento')
        }
        if (!this.casamento.data_casamento && this.casamento.tipo_casamento !== 'Afixação de edital de outra serventia' && this.casamento.tipo_casamento !== 'Casamento Religioso com efeito civil' && this.casamento.tipo_casamento !== 'Conversão de união estável em casamento') {
          messageErrors.push('Informe a data do Casamento')
        }
        if (!this.casamento.hora_casamento && this.casamento.tipo_casamento !== 'Afixação de edital de outra serventia' && this.casamento.tipo_casamento !== 'Casamento Religioso com efeito civil' && this.casamento.tipo_casamento !== 'Conversão de união estável em casamento') {
          messageErrors.push('Informe a hora do Casamento')
        }
        if (!this.casamento.registro.folha) {
          messageErrors.push('Informe o número da folha')
        }
        if (!this.casamento.registro.livro.num_livro) {
          messageErrors.push('Informe o número do livro')
        }
        if (!this.casamento.registro.termo) {
          messageErrors.push('Informe o número do registro')
        }

        return messageErrors
      },
      showErrorList (errors) {
        const textSwal = `<ul>${errors.map(res => {
          return `<li>${res}</li>`
        })}</ul>`

        const html = textSwal.replace(/\,/g,'')

        return this.displayError('HTML', html)
      },
      bloquearRegistro (status) {
        this.atualizarRegistro({
          codigo: status ? 30 : 10,
          dataAverb: null
        })
      }
    }
  }
</script>

<style lang="scss">
  @import "./src/scss/_components/resumos";
  .headerBlueEdicao{
    height: 215px;
  }
  .headerEditHabilitacao{
    position: relative;
    right: 40px;
  }
  .casamentoTitle{
    position: relative;
    top:95px;
    height: 50%;
  }

  .headerTitle {
    @extend %titleBox--sm;
    background-color: $color-gray-light;

    &_error {
      color: #8B0000;
    }
  }

  .icon-error {
    width: 22px;
    height: 22px;
    margin: 0;
    padding: 0;
  }

  .label_error {
    color: #8B0000
  }

  .icon-error-campo {
    width: 15px;
    height: 15px;
    margin: 0;
    padding: 0;
    fill: #8B0000;
  }

  .border-error {
    border: 1px solid red;
    border-radius: 5px;
  }
</style>
